import React from 'react'
import style from './style.scss'

const BotAvatar = props => {
  return <div className={`${style.defaultAvatar} botpress__default-avatar`} />
}

export default BotAvatar



// WEBPACK FOOTER //
// ./src/views/web/bot_avatar.jsx